/*global Adcurve */

Adcurve.isFieldAsValueRule = function(rule) {
  return typeof rule.data !== 'undefined' && typeof rule.data.fieldToCompare !== 'undefined';
};
Adcurve.getRuleValue = function(rule, product) {
  return Adcurve.isFieldAsValueRule(rule) ? (product[rule.data.fieldToCompare] || '') : rule.value;
};
